import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
const routerOptions = [
  { name: 'Dashboard', path: '/Dashboard', component: 'Dashboard' },
  { name: 'Home', path: '/', component: 'Home' },
  {
    name: 'Devices', path: '/devices', component: 'devices',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'rake_dtls', path: '/rake_dtls', component: 'rake_dtls',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Devices_of_pf', path: '/devices_on_pf', component: 'devices_on_pf',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Trains', path: '/trains', component: 'trains',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'GoodsAnalysis', path: '/goodsanalysis', component: 'goodsanalysis',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest',"HOG"]
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'ChartAnalysis', path: '/speedcharthigh_multiple', component: 'speedcharthigh_multiple',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Positions', path: '/positions', component: 'positions',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Section wise Analysis', path: '/section_wise_analysis', component: 'section_wise_analysis',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Crew wise Analysis', path: '/crew_wise_analysis', component: 'crew_wise_analysis',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Train wise Analysis', path: '/train_wise_analysis', component: 'train_wise_analysis',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Rake wise Analysis', path: '/rake_wise_analysis', component: 'rake_wise_analysis',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'PF Enter Speed', path: '/pf_enter_high', component: 'pf_enter_high',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Asign Train', path: '/device-train-map', component: 'device-train-map',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Train Master', path: '/train_master', component: 'train_master',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Train Details', path: '/train_dtls', component: 'train_dtls',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Train Details exel', path: '/trainsdtl', component: 'trainsdtl',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Rake Link Tree', path: '/rake_tree', component: 'rake_tree',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Rake Link', path: '/rakelinkdtl', component: 'rakelinkdtl',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Rake Changment', path: '/rake_changement', component: 'rake_changement',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Train with Rake', path: '/trainswithrake', component: 'trainswithrake',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Attachment Report', path: '/attachment_report', component: 'attachment_report',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  { name: 'Signin', path: '/signin', component: 'Signin' },
  {
    name: 'Signup', path: '/signup', component: 'Signup',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  { name: 'About', path: '/about', component: 'About' },
  {
    name: 'SpeedChartHigh', path: '/speedcharthigh', component: 'speedcharthigh',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Simple', path: '/Simple', component: 'Simple',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Large Display', path: '/live_view_l', component: 'live_view_l',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Live View(S)', path: '/live_view_split', component: 'live_view_split',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'SimpleReplay', path: '/SimpleReplay', component: 'SimpleReplay',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Geofenc', path: '/DrawGeofenceOnMap', component: 'DrawGeofenceOnMap',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Caution', path: '/DrawCautionOnMap', component: 'DrawCautionOnMap',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'CMS Caution', path: '/cautions', component: 'cautions',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin' ,'TLC', 'DTNL',]
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'SpeedOnMap', path: '/SpeedOnMap', component: 'SpeedOnMap',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'powerCarChartHigh', path: '/powerCarChartHigh', component: 'powerCarChartHigh',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'HogChartHigh', path: '/HogChartHigh', component: 'HogChartHigh',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest',"HOG"]
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'hog_trains', path: '/hog_trains', component: 'hog_trains',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest',"HOG"]
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'hog_report', path: '/hog_report', component: 'hog_report',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest',"HOG"]
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'hog_report_sum', path: '/hog_report_sum', component: 'hog_report_sum',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest',"HOG"]
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'TrainsReport', path: '/trainsreport', component: 'trainsreport',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest',"HOG"]
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'HourlyAnalysis', path: '/hourly_analysis', component: 'hourly_analysis',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'LateRunTrains', path: '/latetrains', component: 'latetrains',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'runningtrains', path: '/runningtrains', component: 'runningtrains',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'LiveStation', path: '/livestation', component: 'livestation',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL', 'Guest']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'DestTrains', path: '/desttrains/:north_south', component: 'desttrains',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Train Master(t)', path: '/trainstab', component: 'trainstab',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Notifications', path: '/messages', component: 'messages',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Platform Pos', path: '/platformpos', component: 'platformpos',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Platform Rake', path: '/platformdtl', component: 'platformdtl',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'Auto PF Report', path: '/auto_attach_rep', component: 'auto_attach_rep',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },

  {
    name: 'Auto Attachment Report', path: '/auto_attach_rep', component: 'auto_attach_rep',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'auto_attach_pf_rep', path: '/auto_attach_pf_rep', component: 'auto_attach_pf_rep',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  },
  {
    name: 'auto_attach_log', path: '/auto_attach_log', component: 'auto_attach_log',
    beforeEnter: (to, from, next) => {
      const roles = ['Admin', 'TLC', 'DTNL']
      if (!showRoute(roles)) next('/signin')
      else next()
    }
  }
]
function showRoute(roles) {
  if (roles[0] === 'All') {
    return true
  }
  if (store.state.curUser && roles.indexOf(store.state.curUser.user_type) >= 0) {
    return true
  }
  return false
}
const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/views/${route.component}.vue`)
  }
})

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes
})
